import React, { useContext, useState } from "react";

const ClassContext = React.createContext();
const SetClassContext = React.createContext();

export function useClass() {
  return useContext(ClassContext);
}

export function useSetClass() {
  return useContext(SetClassContext);
}

export function ClassProvider({ children }) {
  const [classObject, setClass] = useState({});

  return (
    <ClassContext.Provider value={classObject}>
      <SetClassContext.Provider value={setClass}>
        {children}
      </SetClassContext.Provider>
    </ClassContext.Provider>
  );
}
